import React from "react";

const AboutJMTY = () => (
  <section className="ls container-px-0 c-gutter-0">
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6">
          <div className="upcoming-section embed-responsive embed-responsive-4by3 cs cs2 s-overlay"></div>
        </div>
        <div className="col-lg-6 text-center text-md-left">
          <div className="section-center">
            <h5 className="above special-heading">"Just Moved to Yankee"</h5>
            <h4 className="special-heading underline">
              What inspired this concept
            </h4>
            <div className="divider-40"></div>
            <p>
              I (Kemi) moved to the US (West Virginia) from Nigeria for college
              when I was just 15. It was incredibly tough adjusting to life in a
              new country by myself. Once I was done with college, I moved to
              Dallas, TX for grad school. It was there I met Dumebi who had also
              moved from Nigeria to pursue her Masters in Economics.
            </p>
            <p>
              We immediately bonded over our love for finance as well as over
              the struggles that international students face in the US-from
              dealing with the loneliness that comes with leaving your family
              behind, to finding an employer willing to hire you and hopefully
              sponsor your work visa, to ultimately settling to life in the US.
              It can get really overwhelming and surprisingly there was not a
              lot of information to help us. We knew right away that we wanted
              to solve this problem and make a difference in the international
              student community. And so together, we started JustMovedToYankee
              (JMTY). In case you were wondering, Yankee is a Nigerian slang for
              the USA.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutJMTY;
